import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { UserService } from '../../services';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: true
})
export class LoginComponent implements OnInit {
  buildversion?: string;
  appname?: string;

  constructor(@Inject(OKTA_AUTH) private oktaAuth: OktaAuth
    , private router: Router
    , @Inject('CONFIG_SETTINGS') config: any
    , private userService: UserService) {
    const configSettings = config['appbuild'];
    this.buildversion = configSettings['version'];
    this.appname = configSettings['name'];
  }

  async ngOnInit() {
    // check if the user is already authenticated.
    // if so route them to the home page

    const isAuthenticated = await this.oktaAuth.isAuthenticated();

    if (isAuthenticated) {
      this.router.navigate(['home']);
    }
  }

  login() {
    this.oktaAuth.signInWithRedirect();
  }
}
